import React from "react";
import { Link } from "react-router-dom";
import "./HiddenLinkMenu.css";

function HiddenLinkMenu(props) {
  console.log(props);
  return (
    <div className="hiddenLinkMenu">
      <ul className="hiddenLinkMenu__list">
        {props.data.map((el) => {
          return (
            <li key={el.id} className="hiddenLinkMenu__item">
              <Link
                className="hiddenLinkMenu__link"
                to={el.link}
                onClick={props.onClick}
              >
                {el.tittle}
              </Link>
            </li>
          );
        })}
      </ul>
    </div>
  );
}

export default HiddenLinkMenu;
